import { faCheck, faPaperPlane, faPlus, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Countdown from 'react-countdown';
import ErrorAdd from "../../../util/ErrorAdd";



function ModalContactConfirm(props) {
    const { show, onHide, id_type } = props;

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(false);

    const [val, setVal] = useState(null);
    const [code, setCode] = useState(null);
    const [codeEnd, setCodeEnd] = useState(null);
    const [codeActive, setCodeActive] = useState(false);//Указывает активный код или нет.

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false);
            setVal(null);
            setCode(null);
            setStep1(true);
            setStep2(false);
            setCodeActive(false);
        }
    }, [show]);

    //Проверит корректность всех данных и отправит код.
    function contactBeforeHandler() {
        setLoading(true);
        setLog(null);

        if (val === null || val === '' || val === undefined) {
            setLog('Введите значение!');
            setLoading(false);
        }
        else {
            axios.post('/api_tracker/user/contactBefore', { ID_Type: id_type, Val: val })
                .then((res) => {
                    if (res.data.Status !== 1) {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                    else {
                        setCodeEnd(res.data.Data.Code_End);
                        setStep1(false);
                        setStep2(true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    function codeEnterHandler() {
        setLoading(true);
        setLog(null);

        if (code === null || code === '' || code === undefined) {
            setLog('Введите код!');
            setLoading(false);
        }
        else {
            axios.post('/api_tracker/user/contactBeforeCodeEnter', { ID_Type: id_type, Val: val })
                .then((res) => {
                    if (res.data.Status !== 1) {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                    else {
                        onHide();
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }


    //Событие запуска таймера
    function timeStartHandler() {
        setCodeActive(true);
    }
    //Событие завершения отсчета
    function timeCompleteHandler() {
        setLog(null);
        setCodeActive(false);
        setStep1(true);
        setStep2(false);
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div><i className="mr-5"><FontAwesomeIcon icon={faPlus} /></i>
                            {id_type === 1 && 'Добавление Email'}
                            {id_type === 2 && 'Добавление номера телефона'}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    {step1 === true && (
                        <>
                            <div className="mb-25">
                                {id_type === 1 && (<Form.Label>Введите Email</Form.Label>)}
                                {id_type === 2 && (<Form.Label>Введите номер телефона</Form.Label>)}
                                <Form.Control type="text" defaultValue={val} onChange={(e) => setVal(e.target.value)} />
                            </div>
                            <div className="mb-3 text-center">
                                <button
                                    className="btn-square btn-hover-shine btn btn-secondary"
                                    type="submit"
                                    onClick={() => contactBeforeHandler()}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <div><FontAwesomeIcon icon={faPaperPlane} className="mr-5" /> Отправка кода...</div>
                                    ) : (
                                        <div><FontAwesomeIcon icon={faPaperPlane} className="mr-5" /> Отправить код подтверждения</div>
                                    )}
                                </button>
                                {log !== null && <div className="form_error text-left">{log}</div>}
                            </div>
                        </>
                    )}
                    {step2 === true && (
                        <>
                            <div className="mb-10">
                                <Form.Label>Введите код подтверждения</Form.Label>
                                <Form.Control type="text" defaultValue={code} onChange={(e) => setCode(e.target.value)} />
                            </div>
                            <div className="mb-10 text-center">
                                <Countdown className="countdown"
                                    date={codeEnd}
                                    onStart={() => timeStartHandler()}
                                    onComplete={() => timeCompleteHandler()}
                                />
                            </div>
                            <div className="mb-3 text-center">
                                <button
                                    className="btn-square btn-hover-shine btn btn-secondary"
                                    type="submit"
                                    onClick={() => codeEnterHandler()}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <div><FontAwesomeIcon icon={faCheck} className="mr-5" /> Загрузка...</div>
                                    ) : (
                                        <div><FontAwesomeIcon icon={faCheck} className="mr-5" /> Подтвердить</div>
                                    )}
                                </button>
                                {log !== null && <div className="form_error text-left">{log}</div>}
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalContactConfirm;
